import * as ReactDOMClient from "react-dom/client";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const container = document.getElementById("root");
const root = ReactDOMClient.createRoot(container);
root.render(<App />);

serviceWorkerRegistration.register();
